module.exports = __webpack_public_path__ + "static/media/A5-flyer.d97dd911.png";